var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandshakeFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 96 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M484 936q-17 0-29-11.787-12-11.788-12-29.213 0-7 3-14.5t9-13.5l185-185-21-21-185 185q-6 6-13 9t-15 3q-17 0-28.5-11.5T366 818q0-10 3-16.5t8-11.5l185-185-21-21-185 184q-6 6-13 9t-16 3q-16 0-28-12t-12-28q0-8 3-15t9-13l185-185-21-21-184 185q-5 5-12 8t-17 3q-17 0-28.5-11.213Q210 679.575 210 663q0-8 3-15t9-13l223-223 127 127q11 11 24.5 18.5T629 565q32 0 54-20.5t22-55.5q0-14-5.5-27.5T681 435L502 256l6-7q17-16 38-24.5t42-8.5q26 0 48 8.5t40 26.5l169 170q18 18 26.5 40t8.5 51q0 20-9 40.5T845 590L512 924q-8 8-14 10t-14 2ZM169 644l-54-54q-17-16-26-38t-9-46q0-26 10-48t25-37l169-170q16-16 38-25.5t43-9.5q27 0 48 7.5t41 27.5l205 205q9 9 12.5 17t3.5 16q0 20-13 33t-33 13q-9 0-18.5-4.5T592 517L444 369 169 644Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshakeFill);
export default __webpack_public_path__ + "static/media/handshake-fill.237ec635b8c269c0dbb787bad4513014.svg";
export { ForwardRef as ReactComponent };